import React, { useState } from 'react';
import './Content.css';
import './Surveys.css';
import PracticeCanada from '../Images/PracticeCanada.jpg';
import PracticeChina from '../Images/PracticeChina.jpg'
import PracticePhilippines from '../Images/PracticePhilippines.jpg';
import PracticeVenezuela from '../Images/PracticeVenezuela.jpg';

function Surveys() {
  // State variables to manage selected filter options
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedDifficulty, setSelectedDifficulty] = useState('');

  // Function to handle filter button click
  const handleFilterClick = () => {
    // Construct the filter URL based on selected options
    const filterUrl = `/filtered-surveys/${selectedCountry}/${selectedCategory}/${selectedDifficulty}`;
    
    // Redirect to the filtered surveys page
    window.location.href = filterUrl;
  };

  // Function to handle starting the survey
  const handleStartSurvey = (country) => {
    // Redirect to the survey page without filtering options
    window.location.href = `/surveys/practice/${country.toLowerCase()}`;
  };

  return (
    <div className='container'>
      <div className='card mt-4'>
        <div className='card-body'>
          <h2>Surveys Page</h2>
          <div className='card mt-4 body'>
            <div className='card-body'>
              {/* Filter section */}
              <div className="filter-section mt-4">
                <h3>Filter Surveys</h3>
                {/* Country filter */}
                <div className="form-group">
                  <label htmlFor="country">Country:</label>
                  <select
                    id="country"
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                  >
                    <option value="">Select Country</option>
                    <option value="Canada">Canada</option>
                    <option value="China">China</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Venezuela">Venezuela</option>
                  </select>
                </div>
                {/* Culture Category filter */}
                <div className="form-group">
                  <label htmlFor="category">Culture Category:</label>
                  <select
                    id="category"
                    className="form-control"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="">Select Category</option>
                    <option value="Food">Food</option>
                    <option value="Festivals">Festivals</option>
                    <option value="Language">Language</option>
                    <option value="Traditions">Traditions</option>
                    <option value="Touristic places">Touristic places</option>
                  </select>
                </div>
                {/* Difficulty Level filter */}
                <div className="form-group">
                  <label htmlFor="difficulty">Difficulty Level:</label>
                  <select
                    id="difficulty"
                    className="form-control"
                    value={selectedDifficulty}
                    onChange={(e) => setSelectedDifficulty(e.target.value)}
                  >
                    <option value="">Select Difficulty</option>
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Advanced">Advanced</option>
                    <option value="All Levels">All Levels</option>
                  </select>
                </div>
                {/* Filter button */}
                <button className="filter-button" onClick={handleFilterClick}>
                  Filter
                </button>
              </div>

              {/* Header for Practice Surveys */}
              <h3 className="practice">Practice Surveys</h3>              

              {/* Canada Survey details */}
              <div className="survey-details mt-4">
                {/* Image of the country */}
                <img src={PracticeCanada} alt="Canada" className="country-image" />
                {/* Survey title */}
                <h3 className="survey-title">Canada</h3>
                {/* Filtering information */}
                <p className="filtering-info">Test your knowledge!</p>
                {/* Start button */}
                <button className="start-button" onClick={() => handleStartSurvey('Canada')}>
                  Start
                </button>
              </div>

              {/* China Survey details */}
              <div className="survey-details mt-4">
                {/* Image of the country */}
                <img src={PracticeChina} alt="China" className="country-image" />
                {/* Survey title */}
                <h3 className="survey-title">China</h3>
                {/* Filtering information */}
                <p className="filtering-info">Wanna know how good you are?</p>
                {/* Start button */}
                <button className="start-button" onClick={() => handleStartSurvey('China')}>
                  Start
                </button>
              </div>

              {/* Philippines Survey details */}
              <div className="survey-details mt-4">
                {/* Image of the country */}
                <img src={PracticePhilippines} alt="Philippines" className="country-image" />
                {/* Survey title */}
                <h3 className="survey-title">Philippines</h3>
                {/* Filtering information */}
                <p className="filtering-info">How much do you know?</p>
                {/* Start button */}
                <button className="start-button" onClick={() => handleStartSurvey('Philippines')}>
                  Start
                </button>
              </div>

              {/* Venezuela Survey details */}
              <div className="survey-details mt-4">
                {/* Image of the country */}
                <img src={PracticeVenezuela} alt="Venezuela" className="country-image" />
                {/* Survey title */}
                <h3 className="survey-title">Venezuela</h3>
                {/* Filtering information */}
                <p className="filtering-info">Unlock your cultural insight!</p>
                {/* Start button */}
                <button className="start-button" onClick={() => handleStartSurvey('Venezuela')}>
                  Start
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Surveys;
